
import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData, uploadImage } from "../../../services/api";
import { hideAddPlanModal } from "./plansModalDispatcher";

  

  export const addPlanRequest = (data, navigate) => {
    return async (dispatch) => {
      dispatch({"type":"ADD_PLAN_REQUEST"});
      try {
        var planResponse = (data.id)? await updateData(data, `${ApiURLs.PLAN}/${data.id}`):await postData(data, ApiURLs.PLAN);
        if (planResponse.status === 1) {
          dispatch({"type":"ADD_PLAN_SUCCESS"});
          dispatch(hideAddPlanModal());
          dispatch(planLisitingRequest());
        } else {
          dispatch({"type":"ADD_PLAN_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"ADD_PLAN_FAILED"});
  
      }
    };
  };




  export const planLisitingRequest = () => {

    return async (dispatch) => {

      const url = `${ApiURLs.PLAN}`;
  
      // wait untill the data not received so getData function take data and url part
      dispatch({"type":"GET_PLAN_REQUEST"});
      try {
        var planData = await fetchData(url);
        console.log(`response when we try to get plan  ${JSON.stringify(planData)}`)
        if (planData.status === 1) {
          dispatch({"type":"GET_PLAN_REQUEST_SUCCESS", "payload":planData.data.result});
        
        } else {
          dispatch({"type":"GET_PLAN_REQUEST_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"GET_PLAN_REQUEST_FAILED"});
        console.log(`error while try to get plan  ${error}`)
      }
    }
  };



    export const deletePlan = (id) => {
      return async (dispatch) => {
    
        // dispatch();
        dispatch({"type":"DELETE_PLAN_REQUEST"});
        try {
    
  
          var planResponse = await deleteData(`${ApiURLs.PLAN}/${id}`);
          if (planResponse.status === 1) {
            dispatch({"type":"ADD_PLAN_SUCCESS"});
            dispatch(planLisitingRequest());
          } else {
            dispatch({"type":"ADD_PLAN_FAILED"});
          }
        } catch (error) {
          dispatch({"type":"ADD_PLAN_FAILED"});
    
        }
      };
    };
  

  //   return async (dispatch) => {
  //     dispatch({ type: "GET_SUBCATEGORY_REQUEST", payload: categoryId });
  
  //     try {
  //       const url = `${ApiURLs.CATEGORIES}?categoryId=${categoryId}`;
  //       var subcategoryRes = await fetchData(url);
  
  //       if (subcategoryRes.status === 1) {
  //         dispatch({
  //           type: "GET_SUBCATEGORY_SUCCESS",
  //           payload: { categoryId, subcategories: subcategoryRes.data.result },
  //         });
  //       } else {
  //         dispatch({
  //           type: "GET_SUBCATEGORY_FAILED",
  //           payload: categoryId,
  //         });
  //       }
  //     } catch (error) {
  //       dispatch({
  //         type: "GET_SUBCATEGORY_FAILED",
  //         payload: categoryId,
  //       });
  //       console.log(`Error while fetching subcategories: ${error}`);
  //     }
  //   };
  // };




  // export const deleteCategory = (id, parentId) => {
  //   return async (dispatch) => {
  
  //     // dispatch();
  //     dispatch({"type":"ADD_CATEGORY_REQUEST"});
  //     try {
  

  //       var categoryResponse = await deleteData(`${ApiURLs.CATEGORIES}/${id}`);
  //       if (categoryResponse.status === 1) {
  //         dispatch({"type":"ADD_CATEGORY_SUCCESS"});
  //         dispatch(categoryLisitingRequest(parentId));
  //       } else {
  //         dispatch({"type":"ADD_CATEGORY_FAILED"});
  //       }
  //     } catch (error) {
  //       dispatch({"type":"ADD_CATEGORY_FAILED"});
  
  //     }
  //   };
  // };


  

